interface SocialMediaTranslationModel {
    followUs: string;
}

const defaultSocialMediaTranslation: Required<SocialMediaTranslationModel> = {
    followUs: 'Obserwuj nas:',
};

export { type SocialMediaTranslationModel, defaultSocialMediaTranslation };
